export { default } from "./NavRight";
